import { defineStore } from "pinia";
import { CapacityHistoryState } from "@core/store/types/admin/offers/capacity";
import { GET_CAPACITY_HISTORY } from "@core/store/action-constants";
import { OffersService as GqlOffersService } from "@core/services/admin/offers/OffersService";

export const useCapacityHistory = defineStore("admin/capacityAndBumps/history", {
  state: (): CapacityHistoryState => ({
    isActive: false,
    data: null,
    pagination: {
      perPage: 10,
      page: 1
    },
    modal: {
      userId: null,
      offerId: null
    }
  }),

  actions: {
    async [GET_CAPACITY_HISTORY] () {
      const limit = this.pagination?.perPage || 10;
      const offset = limit * ((this.pagination?.page || 1) - 1);
      const { userId, offerId } = this.modal;
      
      this.data = await GqlOffersService.getUserCapacityHistory(limit, offset, userId, offerId);
    }
  }
});